import React, { StrictMode } from 'react';
import './styles/global.css';
import ReactDOM from 'react-dom/client';
import App from './App';
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(<App />); // Correct: only pass the root component